import { useMutation, useQueryClient } from "react-query";
import { gql } from "graphql-request";
import { IProgram } from "@pbm/programs/contracts";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { ensureFloat } from "@common/helpers";

export function useUpdateProgram() {
  const queryClient = useQueryClient();
  const { request } = usePbm2Url();

  return useMutation(async (variables: any) => {
    variables.establishmentIdentity = variables.establishmentIdentity.replace(
      /\D/g,
      ""
    );
    variables.defaultTax = ensureFloat(variables.defaultTax);

    const { Rules_updateProgram } = await request(
      gql`
        mutation ($input: Rules_UpdateProgramInput!) {
          Rules_updateProgram(input: $input) {
            code
            name
            type
            createdAt
            updatedAt
            deletedAt
            effectiveSince
            effectiveUntil
          }
        }
      `,
      {
        input: {
          code: variables.code,
          establishmentIdentity: variables.establishmentIdentity,
          defaultTax: variables.defaultTax,
          description: variables.description,
          enableAdhesion: variables.enableAdhesion,
          name: variables.name,
          type: variables.type,
          effectiveSince: variables.effectiveSince,
          effectiveUntil: variables.effectiveUntil,
          logo: variables.logo,
          banner: variables.banner,
          comercialCondition: variables.comercialCondition,
          emailImage: variables.emailImage,
          registrationPeriodStart: variables.registrationPeriodStart,
          registrationPeriodEnd: variables.registrationPeriodEnd,
        },
      }
    );
    await queryClient.invalidateQueries(`program:${variables.code}`);
    return Rules_updateProgram as IProgram;
  });
}
